import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { FactoryWeightPointAddEditSchema } from '../FactoryWeightPointSchema'
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import collectionCatagoryService from '../../CollectionCategory/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import routeService from '../../Route/services';

const screenCode = 'FACTORYWEIGHPOINT';

export function FactoryWeightPointAddEdit(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Add Factory Weight Point");
    const [buttonText, setButtonText] = useState("Save");
    const [groups, setGroups] = useState();
    const [operationEntity, setOperationEntity] = useState();
    const [collectionCatagory, setCollectionCatagory] = useState();
    const [factoryWeightPointFiltering, setFactoryWeightPointFiltering] = useState({
        groupID: '0',
        operationEntityID: '0',
        collectionPointID: '0',
        collectionPointCode: '',
        collectionPointName: '',
        collectionPointLocation:'',
        collectionCategoryID: '0',
        isActive: true
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "completed successfuly."
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(FactoryWeightPointAddEditSchema).options({ allowUnknown: true });

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        )
    }, [factoryWeightPointFiltering.groupID]);

    useEffect(() => {
        trackPromise(
            getCollectionCatagoryForDropDown()
        )
    }, [factoryWeightPointFiltering.operationEntityID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITFACTORYWEIGHPOINT');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !==undefined
        });

        if (data && edit) {
            setTitle("Edit Factory Weight Point");
            setFactoryWeightPointFiltering(data);
            setButtonText("Update");
        } else {
            setTitle("Add Factory Weight Point");
            var token = tokenService.getUserDetailsFromToken();
            setFactoryWeightPointFiltering({
                ...factoryWeightPointFiltering,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }

        trackPromise(
            getGroupsForDropdown()
        );
    }


    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntitiesForDropdown() {
        const operationEntities = await routeService.getFactoryByGroupID(factoryWeightPointFiltering.groupID);
        setOperationEntity(operationEntities);
    }

    async function getCollectionCatagoryForDropDown() {
        const collectionCatagory = await collectionCatagoryService.GetCollectionCategoryByOperationEntityID(factoryWeightPointFiltering.operationEntityID);
       
        setCollectionCatagory(collectionCatagory);
    }

    function handleChange(e) {
        const target = e.target;

        const value = target.name === 'isActive' ? target.checked : target.value


        if (target.name === "collectionCategoryCode") {
            if (target.value.length === 3) return false
        }


        const error = { ...errors };
        const errorMessage = validateProperty(target, FactoryWeightPointAddEditSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setFactoryWeightPointFiltering({
            ...factoryWeightPointFiltering,
            [e.target.name]: value
        });
        setErrors(error);
    }

    async function handleSave(e) {
        e.preventDefault();

        const errorMessages = validate(schema, factoryWeightPointFiltering);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        if (!edit) {
           var result = await services.saveWeighPoint(factoryWeightPointFiltering);
           setMessageModel({ ...messageModel, hidden: false, type: result.statusCode, disciption: result.message });
           afterSuccessfulyChanged(result.statusCode);
        } 
        else if (edit) {
           var result = await services.editWeighPoint(factoryWeightPointFiltering);
           setMessageModel({ ...messageModel, hidden: false, type: result.statusCode, disciption: result.message });
           afterSuccessfulyChanged(result.statusCode);
        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/factoryweightpoint' })
            }, 1500);
        }
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setFactoryWeightPointFiltering({
            ...factoryWeightPointFiltering,
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionPointCode: '',
            collectionPointName: '',
            collectionPointLocation: '',
            isActive: true
        });
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        setErrors({});
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    path="/factoryweightpoint"
                                    buttonText="Back to listing"
                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSave(e)} disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            value={factoryWeightPointFiltering.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            value={factoryWeightPointFiltering.operationEntityID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionCategoryID">Collection Category *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionCategoryID"
                                            id="collectionCategoryID"
                                            name="collectionCategoryID"
                                            disabled={!!edit}
                                            value={factoryWeightPointFiltering.collectionCategoryID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Collection Catagory--</MenuItem>
                                            {generateDropDownMenu(collectionCatagory)}
                                        </Select>
                                        {errors["collectionCategoryID"] && <FormHelperText error>{errors["collectionCategoryID"]}</FormHelperText>}
                                    </div>
                                </div>
                                    <div className="form-group row">
                                        <div className="col-md pb-1">

                                            <TextField fullWidth label="Code *"
                                                name="collectionPointCode"
                                                id="collectionPointCode"
                                                value={factoryWeightPointFiltering.collectionPointCode}
                                                type="number"
                                                onChange={(e) => handleChange(e)} />
                                            {errors["collectionPointCode"] && <span id="errbranchCode" className="text text-danger">{errors["collectionPointCode"]}</span>}
                                        </div>

                                        <div className="col-md pb-1">

                                            <TextField fullWidth label="Name *"
                                                name="collectionPointName"
                                                id="collectionPointName"
                                                value={factoryWeightPointFiltering.collectionPointName}
                                                type="text"
                                                onChange={(e) => handleChange(e)} />
                                            {errors["collectionPointName"] && <span id="errbranchCode" className="text text-danger">{errors["collectionPointName"]}</span>}
                                        </div>

                                        <div className="col-md pb-1">

                                            <TextField fullWidth label="Collection Point Location "
                                                name="collectionPointLocation"
                                                id="collectionPointLocation"
                                                value={factoryWeightPointFiltering.collectionPointLocation}
                                                type="text"
                                                onChange={(e) => handleChange(e)} />
                                            {errors["collectionPointLocation"] && <span id="errbranchCode" className="text text-danger">{errors["collectionPointLocation"]}</span>}
                                        </div>
                                    </div>
                                
                                    <div>
                                        <label>Active</label>
                                        <div className="form-group row">
                                            <div className="col-md ">
                                                <input
                                                    id="isActive"
                                                    switch="none"
                                                    className="mr-2"
                                                    type="checkbox"
                                                    name="isActive"
                                                    onChange={(e) => handleChange(e)}
                                                    checked={factoryWeightPointFiltering.isActive}
                                                />
                                                <label htmlFor="isActive" data-on-label="Yes"
                                                    data-off-label="No"></label>
                                            </div>
                                        </div>
                                    </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, factoryWeightPointFiltering)}
                                        type="submit"
                                        className="btn btn-primary"
                                        value={buttonText}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>

                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}